module.exports = __webpack_public_path__ + "img/180-ea2b50.png";